<template>
  <div class="home-recommend-page">
    <div class="toolbar">
      <el-button type="success" icon="el-icon-plus" style="float: right" @click="openDialog">添加推荐商品</el-button>
    </div>

    <el-table :data="tableData" border stripe v-loading="loading" style="margin-top: 10px">
      <el-table-column label="ID" prop="id" width="70"></el-table-column>
      <el-table-column label="商品ID" prop="goods_id" width="90"></el-table-column>
      <el-table-column label="商品" min-width="220">
        <template slot-scope="scope">
          <div style="display: flex; align-items: center">
            <el-image
              v-if="scope.row.goods.cover"
              :src="scope.row.goods.cover.startsWith('/')?`${baseURL}${scope.row.goods.cover}`:scope.row.goods.cover.startsWith('http')?`${scope.row.goods.cover}`:`${baseURL}/${scope.row.goods.cover}`"
              fit="cover"
              style="width: 56px; height: 56px; border-radius: 4px; margin-right: 10px"
            ></el-image>
            <div>
              <div style="font-size: 13px" v-if="scope.row.goods_name_lang">{{ scope.row.goods_name_lang }}</div>
              <!-- <div style="color: #f56c6c; font-weight: bold" v-if="scope.row.goods_price">￥{{ scope.row.goods_price }}</div> -->
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="排序" width="150">
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.sort"
            :min="0"
            :max="9999"
            size="mini"
            controls-position="right"
            @change="onSortChange(scope.row)"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column label="启用" width="90">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.enable_switch"
            :active-value="1"
            :inactive-value="0"
            @change="onSwitch(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="90" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="onDelete(scope.row)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      style="margin-top: 10px; text-align: right"
      background
      layout="total, prev, pager, next"
      :total="total"
      :current-page.sync="page"
      :page-size="pageSize"
      @current-change="loadList"
    ></el-pagination>

    <!-- 添加推荐弹窗：支持搜索选商品 -->
    <el-dialog title="添加推荐商品" :visible.sync="dialogVisible" width="620px">
      <el-form label-width="80px">
        <el-form-item label="选择商品">
          <el-select
            v-model="selectedGoodsId"
            filterable
            remote
            reserve-keyword
            placeholder="输入商品标题搜索"
            :remote-method="searchGoods"
            :loading="searching"
            style="width: 100%"
          >
            <el-option
              v-for="g in goodsOptions"
              :key="g.id"
              :label="g.title + ' (ID:' + g.id + ')'"
              :value="g.id"
            >
              <span style="float: left">{{ g.name_lang }}</span>
              <span style="float: right; color: #f56c6c; font-size: 12px">ID:{{ g.id }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort" :min="0" :max="9999"></el-input-number>
          <span style="color: #999; margin-left: 8px">数字越小越靠前</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="onSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import request from '@/api/request' // 按你的 request 文件路径改
import { recommendlist, recommenddelete, recommendsave, recommendswitch, recommendsort, goods_list,baseURL } from '../api/api';
export default {
  name: 'HomeRecommend',
  data() {
    return {
        baseURL,
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 10,
      loading: false,
      saving: false,
      searching: false,
      dialogVisible: false,
      goodsOptions: [],
      selectedGoodsId: null,
      form: { sort: 50 }
    }
  },
  mounted() {
    this.loadList()
    // this.searchGoods('') // 初始拉一批商品
  },
  methods: {
    async loadList() {
      this.loading = true
      try {

        const res = await recommendlist({page:this.page,limit:this.pageSize})
        if (res && res.list) {
          this.tableData = res.list
          this.total = res.total
        }
      } catch (e) {
        this.$message.error(e || '加载失败')
      } finally {
        this.loading = false
      }
    },
    openDialog() {
      this.selectedGoodsId = null
      this.form = { sort: 50 }
      this.dialogVisible = true
    },
    // 远程搜索商品
    async searchGoods(keyword) {
      this.searching = true
      try {

        const res = await goods_list(keyword)

        this.goodsOptions = res.list
        
      } catch (e) {
        this.$message.error(e || '搜索失败')
      } finally {
        this.searching = false
      }
    },
    async onSave() {
      if (!this.selectedGoodsId) {
        this.$message.warning('请选择商品')
        return
      }
      this.saving = true
      try {
        const res = await recommendsave({goods_id:this.selectedGoodsId,sort:this.form.sort})
        this.$message.success('添加成功')
        this.dialogVisible = false
        this.loadList()
      } catch (e) {
        this.$message.error(e || '添加失败')
      } finally {
        this.saving = false
      }
    },
    // 开关
    async onSwitch(row) {
      try {

        const res = await recommendswitch({id:row.id,enable_switch:row.enable_switch})
    
        this.$message.success(row.enable_switch === 1 ? '已启用' : '已停用')
      } catch (e) {
        row.enable_switch = row.enable_switch === 1 ? 0 : 1
        this.$message.error(e || '操作失败')
      }
    },
    // 排序修改
    async onSortChange(row) {
      try {

        await recommendsort({id:row.id,sort:row.sort})

        this.$message.success('排序已更新')
      } catch (e) {
        this.$message.error(e || '更新失败')
      }
    },
    onDelete(row) {
      this.$confirm('确定移除该推荐商品?', '提示', { type: 'warning' })
        .then(async () => {
          const res = await recommenddelete(row.id)
          this.$message.success('已移除')
          this.loadList()
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.toolbar {
  overflow: hidden;
}
</style>